import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/energyBill/selectList',
    method: 'get',
    params: data,
  });
}

export function selectListWater(data) {
  return request({
    url: '/billWater/selectList',
    method: 'get',
    params: data,
  });
}
